/**
 * Site-Wide Jackpot specific types for MDS message handling.
 */

export const SWJ_MESSAGE_TYPE = 'JACKPOT' as const;
export const SWJ_MESSAGE_SUBTYPES = ['OPT_IN_STATUS'] as const;

export type SwjMessageSubtype = (typeof SWJ_MESSAGE_SUBTYPES)[number];

/**
 * SWJ-specific message structure.
 */
export type SwjMessage = {
    type: typeof SWJ_MESSAGE_TYPE;
    subtype: SwjMessageSubtype;
    userId: string;
    payload: string;
};

/**
 * Parsed payload structure for OPT_IN_STATUS messages.
 */
export type OptInStatusPayload = {
    jackpotId: string;
    optedIn: boolean;
    timestamp: string;
    multiplier: number;
};

/**
 * Callback function type for handling multiplier updates in Zustand store.
 */
export type OptInUpdateCallback = (multiplier: 0 | 1 | 2) => void;
